var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4374 12.548V31.8254C63.4374 49.3812 51.5153 64.6893 34.4858 69C17.4848 64.7035 5.56274 49.3812 5.56274 31.8254V12.548C18.9502 11.04 26.533 5.9468 34.5001 0C42.4671 5.9468 50.0499 11.04 63.4374 12.548Z",
    fill: "#FFD15C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 61.3888C21.6816 57.32 12.8752 45.4263 12.8752 31.8255V18.7653C21.8808 16.802 28.4963 13.1742 34.5 9.03418C40.6317 13.288 47.1192 16.8447 56.1247 18.7795V31.8398C56.1247 45.4263 47.3183 57.32 34.5 61.3888Z",
    fill: "#F8B64C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7055 46.294L22.5779 39.1664L26.1915 35.5386L29.7055 39.0384L42.8084 25.9497L46.422 29.5633L29.7055 46.294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.51e897d6f8c365010f12bbf8579408a8.svg";
export { ForwardRef as ReactComponent };